const createEtransferIndividualStyle = {
	
};

export default createEtransferIndividualStyle;
